<template>

  <div class="min-h-screen bg-slate-900 font-sans overflow-x-hidden">



    <!-- ----------------------------------------------

         NAVBAR

    ---------------------------------------------- -->

    <nav class="fixed top-0 left-0 right-0 z-40 transition-all duration-300"

         :class="scrolled ? 'bg-slate-900/95 backdrop-blur-lg shadow-2xl border-b border-white/5' : 'bg-transparent'">

      <div class="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        <!-- Logo -->

        <div class="flex items-center gap-3">

          <div class="w-10 h-10 rounded-2xl bg-animated-gradient flex items-center justify-center shadow-lg shadow-emerald-500/40">

            <i class="fa-solid fa-laptop-code text-white text-sm"></i>

          </div>

          <span class="text-white font-black text-xl tracking-tight">MADAV<span class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-green-400"> Solutions</span></span>

        </div>



        <!-- Links escritorio -->

        <div class="hidden md:flex items-center gap-8">

          <a href="#servicios" class="text-slate-300 hover:text-white text-sm font-medium transition-colors duration-200">Servicios</a>

          <a href="#como-funciona" class="text-slate-300 hover:text-white text-sm font-medium transition-colors duration-200">¿CÓMO FUNCIONA?</a>

          <a href="#contacto" class="text-slate-300 hover:text-white text-sm font-medium transition-colors duration-200">Contacto</a>

        </div>



        <div class="flex items-center gap-3">

          <router-link

            v-if="!estaAutenticado"

            to="/login"

            class="hidden md:flex items-center gap-2 text-slate-400 hover:text-white text-sm font-medium transition-colors duration-200"

          >

            <i class="fa-solid fa-right-to-bracket text-xs"></i> Iniciar sesión

          </router-link>

          <router-link

            v-else

            :to="esAdmin ? '/admin' : '/cliente'"

            class="hidden md:flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm font-medium transition-colors duration-200"

          >

            <i class="fa-solid fa-circle-user text-xs"></i> {{ usuarioActual.nombre }}

          </router-link>

          <a

            href="#servicios"

            class="hidden sm:inline-flex bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-400 hover:to-green-500 text-white px-5 py-2 rounded-xl text-sm font-semibold shadow-lg shadow-emerald-500/30 transition-all duration-200 hover:scale-105 hover:shadow-emerald-500/50"

          >

            Ver Servicios

          </a>

          <!-- Botón hamburguesa móvil -->

          <button

            class="md:hidden text-slate-300 hover:text-white p-2 rounded-lg transition-colors"

            @click="mobileMenuOpen = !mobileMenuOpen"

          >

            <i :class="mobileMenuOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'" class="text-xl"></i>

          </button>

        </div>

      </div>

      <!-- Menú móvil desplegable -->

      <transition name="fade-up">

        <div

          v-if="mobileMenuOpen"

          class="md:hidden bg-slate-900/98 backdrop-blur-lg border-t border-white/10 px-6 py-4 space-y-3"

        >

          <a href="#servicios"   @click="mobileMenuOpen=false" class="block text-slate-300 hover:text-white py-2 text-sm font-medium border-b border-white/5 transition-colors">Servicios</a>

          <a href="#como-funciona" @click="mobileMenuOpen=false" class="block text-slate-300 hover:text-white py-2 text-sm font-medium border-b border-white/5 transition-colors">¿CÓMO FUNCIONA?</a>

          <a href="#contacto"    @click="mobileMenuOpen=false" class="block text-slate-300 hover:text-white py-2 text-sm font-medium border-b border-white/5 transition-colors">Contacto</a>

          <router-link v-if="!estaAutenticado" to="/login" @click.native="mobileMenuOpen=false" class="flex items-center gap-2 text-slate-400 hover:text-white py-2 text-sm font-medium transition-colors">

            <i class="fa-solid fa-right-to-bracket text-xs"></i> Iniciar sesión

          </router-link>

          <div v-else class="flex items-center justify-between py-2">
            <router-link :to="esAdmin ? '/admin' : '/cliente'" @click.native="mobileMenuOpen=false" class="flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm font-medium transition-colors">
              <i class="fa-solid fa-circle-user text-xs"></i> {{ usuarioActual.nombre }}
            </router-link>
            <button @click="cerrarSesion" class="flex items-center gap-1 text-slate-400 hover:text-red-400 text-sm transition-colors">
              <i class="fa-solid fa-right-from-bracket text-xs"></i>
              <span>Salir</span>
            </button>
          </div>

          <a href="#servicios" @click="mobileMenuOpen=false" class="block w-full text-center bg-gradient-to-r from-emerald-500 to-green-600 text-white px-5 py-2.5 rounded-xl text-sm font-semibold mt-2">

            Ver Servicios

          </a>

        </div>

      </transition>

    </nav>



    <!-- ----------------------------------------------

         HERO SECTION

    ---------------------------------------------- -->

    <section class="relative min-h-screen flex items-center justify-center overflow-hidden">



      <!-- Fondo animado -->

      <div class="absolute inset-0 bg-animated-gradient opacity-20"></div>



      <!-- Grid de puntos decorativos -->

      <div class="absolute inset-0 opacity-10"

           style="background-image: radial-gradient(circle, #ffffff 1px, transparent 1px); background-size: 40px 40px;"></div>



      <!-- Partículas flotantes -->

      <div class="absolute inset-0 overflow-hidden pointer-events-none">

        <div class="particle w-64 h-64 bg-emerald-500" style="top:10%;left:5%;animation-delay:0s;animation-duration:7s;"></div>

        <div class="particle w-48 h-48 bg-green-500" style="top:60%;left:80%;animation-delay:2s;animation-duration:9s;"></div>

        <div class="particle w-32 h-32 bg-pink-500"   style="top:80%;left:20%;animation-delay:4s;animation-duration:6s;"></div>

        <div class="particle w-56 h-56 bg-blue-500"   style="top:20%;left:70%;animation-delay:1s;animation-duration:8s;"></div>

        <div class="particle w-24 h-24 bg-cyan-400"   style="top:45%;left:40%;animation-delay:3s;animation-duration:10s;"></div>

      </div>



      <!-- Contenido hero -->

      <div class="relative z-10 max-w-5xl mx-auto px-6 text-center py-32">

        <!-- Badge -->

        <div class="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 text-sm text-emerald-300 font-medium mb-8 animate-fade-in">

          <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>

          Soluciones digitales para tu negocio

        </div>



        <!-- Título principal -->

        <h1 class="text-6xl md:text-8xl font-black text-white mb-6 leading-none tracking-tight" style="animation: fadeInUp 0.8s ease-out forwards;">

          MADAV<span class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-green-400 to-pink-400"> Solutions</span>

        </h1>



        <p class="text-slate-300 text-xl md:text-2xl font-light mb-4 max-w-2xl mx-auto leading-relaxed" style="animation: fadeInUp 0.8s ease-out 0.2s forwards; opacity:0;">

          Digitaliza tu negocio con nuestros sistemas a medida.

          <span class="text-white font-medium">Rápido, intuitivo y accesible.</span>

        </p>



        <p class="text-slate-400 text-base mb-12" style="animation: fadeInUp 0.8s ease-out 0.4s forwards; opacity:0;">

          Punto de venta · Dental · Consultorio · Gimnasio · Restaurante · Y más

        </p>



        <!-- CTAs -->

        <div class="flex flex-col sm:flex-row items-center justify-center gap-4" style="animation: fadeInUp 0.8s ease-out 0.6s forwards; opacity:0;">

          <a

            href="#servicios"

            class="group flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-400 hover:to-green-500 text-white px-8 py-4 rounded-2xl font-bold text-base shadow-2xl shadow-emerald-500/40 transition-all duration-300 hover:scale-105 hover:shadow-emerald-500/60"

          >

            <i class="fa-solid fa-rocket group-hover:rotate-12 transition-transform duration-200"></i>

            Explorar Servicios

          </a>

          <a

            href="#como-funciona"

            class="flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white px-8 py-4 rounded-2xl font-semibold text-base transition-all duration-300 hover:scale-105"

          >

            <i class="fa-solid fa-play-circle"></i>

            ¿Cómo funciona?

          </a>

        </div>



        <!-- Scroll indicator -->

        <div class="mt-20 flex justify-center" style="animation: fadeInUp 0.8s ease-out 1s forwards; opacity:0;">

          <div class="flex flex-col items-center gap-2 text-slate-500">

            <span class="text-xs tracking-widest uppercase">Desplázate</span>

            <div class="w-px h-12 bg-gradient-to-b from-emerald-400 to-transparent animate-bounce-slow"></div>

          </div>

        </div>

      </div>

    </section>



    <!-- ----------------------------------------------

         STATS

    ---------------------------------------------- -->

    <!-- <section class="py-16 bg-slate-800/50">

      <div class="max-w-5xl mx-auto px-6">

        <div class="grid grid-cols-2 md:grid-cols-4 gap-6">

          <div v-for="stat in stats" :key="stat.label" class="text-center group">

            <div class="text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-green-400 mb-1 group-hover:scale-110 transition-transform duration-200">

              {{ stat.valor }}

            </div>

            <div class="text-slate-400 text-sm">{{ stat.label }}</div>

          </div>

        </div>

      </div>

    </section> -->



    <!-- ----------------------------------------------

         SECCI?"N DE SERVICIOS

    ---------------------------------------------- -->

    <section id="servicios" class="py-24 px-6">

      <div class="max-w-7xl mx-auto">



        <!-- Encabezado de sección -->

        <div class="text-center mb-16">

          <span class="inline-block text-emerald-400 text-sm font-semibold uppercase tracking-widest mb-4">

            <i class="fa-solid fa-stars mr-2"></i>Nuestros Sistemas

          </span>

          <h2 class="text-4xl md:text-5xl font-black text-white mb-4">

            Soluciones para cada<br/>

            <span class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-pink-400"> tipo de negocio</span>

          </h2>

          <p class="text-slate-400 text-lg max-w-2xl mx-auto">

            Elige el sistema que mejor se adapte a tu industria y comienza a digitalizar tu negocio hoy mismo.

          </p>

        </div>



        <!-- Cargando -->

        <div v-if="cargando" class="flex justify-center py-20">

          <div class="flex flex-col items-center gap-4">

            <div class="w-12 h-12 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin"></div>

            <p class="text-slate-400">Cargando sistemas...</p>

          </div>

        </div>



        <!-- Grid de tarjetas de servicios -->

        <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

          <div

            v-for="(sistema, idx) in sistemas"

            :key="sistema.idSistema"

            @click="verPlanes(sistema)"

            class="group relative cursor-pointer rounded-3xl overflow-hidden transition-all duration-500 hover:scale-105 hover:-translate-y-2 service-card-shadow"

            :style="{ background: sistema.gradiente, animationDelay: (idx * 0.1) + 's' }"

          >

            <!-- Overlay de glassmorphism al hover -->

            <div class="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-all duration-300"></div>



            <!-- Patrón decorativo en la esquina -->

            <div class="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/10 group-hover:scale-150 transition-transform duration-500"></div>

            <div class="absolute -bottom-8 -left-8 w-24 h-24 rounded-full bg-white/5 group-hover:scale-125 transition-transform duration-700"></div>



            <!-- Contenido de la tarjeta -->

            <div class="relative p-8 flex flex-col min-h-52">

              <!-- Icono -->

              <div class="text-5xl mb-4 group-hover:scale-110 transition-transform duration-300 w-fit">

                {{ sistema.icono }}

              </div>



              <!-- Nombre -->

              <h3 class="text-white font-bold text-xl mb-2 leading-tight">{{ sistema.nombre }}</h3>



              <!-- Descripción -->

              <p class="text-white/75 text-sm leading-relaxed flex-1">{{ sistema.descripcion }}</p>



              <!-- CTA -->

              <div class="mt-6 flex items-center justify-between">

                <span class="text-white/60 text-xs font-medium uppercase tracking-wider">Ver planes</span>

                <div class="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 group-hover:translate-x-1 transition-all duration-300">

                  <i class="fa-solid fa-arrow-right text-white text-sm"></i>

                </div>

              </div>

            </div>



            <!-- Badge de "planes disponibles" -->

            <div class="absolute top-4 right-4 bg-white/20 backdrop-blur-sm border border-white/30 text-white text-xs font-semibold px-2.5 py-1 rounded-full">

              Ver planes

            </div>

          </div>



          <!-- Tarjeta placeholder "¿No encuentras tu sistema?" -->

          <div class="group relative cursor-default rounded-3xl overflow-hidden border-2 border-dashed border-slate-600 hover:border-emerald-500 transition-all duration-300 min-h-52 flex items-center justify-center p-8">

            <div class="text-center">

              <div class="w-12 h-12 rounded-2xl bg-slate-700 group-hover:bg-emerald-500/20 flex items-center justify-center mx-auto mb-4 transition-colors duration-300">

                <i class="fa-solid fa-plus text-slate-400 group-hover:text-emerald-400 transition-colors duration-300"></i>

              </div>

              <p class="text-slate-400 group-hover:text-slate-300 font-semibold transition-colors duration-300">¿Necesitas algo diferente?</p>

              <p class="text-slate-500 text-sm mt-1">Contáctanos para una solución a medida</p>

            </div>

          </div>

        </div>

      </div>

    </section>



    <!-- ----------------------------------------------

         CÓMO FUNCIONA

    ---------------------------------------------- -->

    <section id="como-funciona" class="py-24 px-6 bg-slate-800/30">

      <div class="max-w-5xl mx-auto">

        <div class="text-center mb-16">

          <span class="inline-block text-green-400 text-sm font-semibold uppercase tracking-widest mb-4">

            <i class="fa-solid fa-diagram-project mr-2"></i>Proceso simple

          </span>

          <h2 class="text-4xl font-black text-white mb-4">¿CÓMO FUNCIONA?</h2>

          <p class="text-slate-400 text-lg">En solo 3 pasos tendrás tu sistema operando.</p>

        </div>



        <div class="grid md:grid-cols-3 gap-8">

          <div v-for="(paso, idx) in pasos" :key="idx" class="relative text-center group">

            <!-- L�Línea conectora -->

            <div v-if="idx < pasos.length - 1"

                 class="hidden md:block absolute top-10 left-1/2 w-full h-px bg-gradient-to-r from-emerald-500/50 to-green-500/50 z-0"></div>



            <div class="relative z-10">

              <div class="w-20 h-20 rounded-3xl mx-auto mb-6 flex items-center justify-center text-3xl shadow-2xl group-hover:scale-110 transition-transform duration-300"

                   :style="{ background: paso.gradiente }">

                {{ paso.icono }}

              </div>

              <div class="w-7 h-7 rounded-full bg-emerald-500 text-white text-xs font-bold flex items-center justify-center mx-auto -mt-10 mb-6 relative z-20 ring-4 ring-slate-900">

                {{ idx + 1 }}

              </div>

              <h3 class="text-white font-bold text-lg mb-2">{{ paso.titulo }}</h3>

              <p class="text-slate-400 text-sm leading-relaxed">{{ paso.descripcion }}</p>

            </div>

          </div>

        </div>

      </div>

    </section>



    <!-- ----------------------------------------------

         CONTACTO / CTA FINAL

    ---------------------------------------------- -->

    <section id="contacto" class="py-24 px-6">

      <div class="max-w-3xl mx-auto text-center">

        <div class="relative bg-gradient-to-br from-emerald-500/20 to-green-600/20 backdrop-blur-sm border border-white/10 rounded-3xl p-12 overflow-hidden">

          <!-- Decoración -->

          <div class="absolute inset-0 bg-animated-gradient opacity-5"></div>

          <div class="absolute top-0 right-0 w-40 h-40 rounded-full bg-green-500/20 -translate-y-1/2 translate-x-1/2"></div>

          <div class="absolute bottom-0 left-0 w-32 h-32 rounded-full bg-emerald-500/20 translate-y-1/2 -translate-x-1/2"></div>



          <div class="relative">

            <div class="text-5xl mb-6">🚀</div>

            <h2 class="text-4xl font-black text-white mb-4">¡Listo para comenzar?</h2>

            <p class="text-slate-300 text-lg mb-8 leading-relaxed">

              Contáctanos y un asesor te ayudará a elegir el sistema y plan ideal para tu negocio.

            </p>

            <div class="flex flex-col sm:flex-row gap-4 justify-center">

              <a

                href="mailto:solutions.madav@gmail.com"

                class="flex items-center justify-center gap-2 bg-white text-emerald-600 px-8 py-4 rounded-2xl font-bold shadow-2xl hover:bg-emerald-50 transition-all duration-200 hover:scale-105"

              >

                <i class="fa-solid fa-envelope"></i> Enviar correo

              </a>

              <a

                href="https://wa.me/526673041527"

                class="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white px-8 py-4 rounded-2xl font-bold shadow-2xl transition-all duration-200 hover:scale-105"

              >

                <i class="fa-brands fa-whatsapp text-lg"></i> WhatsApp

              </a>

            </div>

          </div>

        </div>

      </div>

    </section>



    <!-- ----------------------------------------------

         FOOTER

    ---------------------------------------------- -->

    <footer class="border-t border-white/5 py-10 px-6 text-center">

      <div class="max-w-5xl mx-auto">

        <div class="flex items-center justify-center gap-3 mb-4">

          <div class="w-8 h-8 rounded-xl bg-animated-gradient flex items-center justify-center">

            <i class="fa-solid fa-laptop-code text-white text-xs"></i>

          </div>

          <span class="text-white font-bold text-lg">MADAV<span class="text-emerald-400"> Solutions</span></span>

        </div>

        <p class="text-slate-500 text-sm">© {{ aniActual }} MADAV Solutions · Todos los derechos reservados.</p>

        <div class="flex justify-center gap-6 mt-4">

          <!-- <router-link to="/admin" class="text-slate-600 hover:text-emerald-400 text-xs transition-colors duration-200">

            <i class="fa-solid fa-shield-halved mr-1"></i>Admin

          </router-link> -->

          <a href="#servicios" class="text-slate-600 hover:text-emerald-400 text-xs transition-colors duration-200">Servicios</a>

          <a href="#contacto"  class="text-slate-600 hover:text-emerald-400 text-xs transition-colors duration-200">Contacto</a>

        </div>

      </div>

    </footer>



    <!-- ----------------------------------------------

         MODAL DE PLANES

    ---------------------------------------------- -->

    <transition name="modal">

      <div

        v-if="modalPlanes"

        class="fixed inset-0 z-50 flex items-start justify-center modal-overlay overflow-y-auto py-8 px-4"

        @click.self="cerrarModal"

      >

        <div class="bg-slate-900 rounded-3xl w-full max-w-5xl shadow-2xl border border-white/10 my-auto">



          <!-- Header del modal -->

          <div

            class="relative p-8 rounded-t-3xl overflow-hidden"

            :style="sistemaSeleccionado ? { background: sistemaSeleccionado.gradiente } : {}"

          >

            <div class="absolute inset-0 bg-black/20"></div>

            <div class="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/10"></div>

            <div class="relative flex items-start justify-between">

              <div>

                <p class="text-white/70 text-sm font-medium mb-1 uppercase tracking-widest">Planes disponibles</p>

                <h3 class="text-white font-black text-3xl flex items-center gap-3">

                  <span class="text-4xl">{{ sistemaSeleccionado && sistemaSeleccionado.icono }}</span>

                  {{ sistemaSeleccionado && sistemaSeleccionado.nombre }}

                </h3>

                <p class="text-white/70 mt-2 max-w-lg">{{ sistemaSeleccionado && sistemaSeleccionado.descripcion }}</p>

                <!-- Etiqueta de promoción vigente -->
                <div v-if="promocionesAplicables.length > 0" class="flex flex-wrap gap-2 mt-4 pr-6">
                  <span
                    v-for="promo in promocionesAplicables"
                    :key="promo.idPromocion"
                    class="inline-flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-extrabold bg-white/20 backdrop-blur-sm text-white border border-white/30 shadow-xl tracking-wide"
                  >
                    <i class="fa-solid fa-fire text-orange-300 text-base"></i>
                    {{ promo.nomPromocion }}
                  </span>
                </div>

              </div>

              <div class="flex flex-col items-end gap-3 flex-shrink-0 ml-4">

                <button

                  @click="cerrarModal"

                  class="w-10 h-10 rounded-xl bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-all duration-200"

                >

                  <i class="fa-solid fa-xmark"></i>

                </button>

                <!-- Badge descuento -->

                <div
                  v-if="promocionesAplicables.length > 0"
                  v-for="promo in promocionesAplicables"
                  :key="'pct-' + promo.idPromocion"
                  class="flex flex-col items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-400 to-pink-500 shadow-2xl shadow-orange-500/50 border-2 border-white/30 animate-bounce"
                >
                  <span class="text-white text-2xl font-black leading-none">{{ promo.porcentaje }}%</span>
                  <span class="text-white/90 text-xs font-bold uppercase tracking-wide leading-none mt-1">OFF</span>
                </div>

              </div>

            </div>

          </div>



          <!-- Cuerpo del modal -->

          <div class="p-8">

            <!-- Cargando planes -->

            <div v-if="cargandoPlanes" class="flex flex-col items-center py-12 gap-4">

              <div class="w-10 h-10 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin"></div>

              <p class="text-slate-400">Cargando planes...</p>

            </div>



            <!-- Sin planes -->

            <div v-else-if="planes.length === 0" class="text-center py-12">

              <i class="fa-solid fa-box-open text-4xl text-slate-600 mb-3 block"></i>

              <p class="text-slate-400">No hay planes disponibles para este sistema.</p>

            </div>



            <!-- Grid de planes -->

            <div v-else class="grid md:grid-cols-3 gap-6">

              <div

                v-for="(plan, idx) in planes"

                :key="plan.idPlan"

                :class="['relative rounded-2xl border p-6 flex flex-col transition-all duration-300 hover:scale-105',

                         idx === 1

                           ? 'border-emerald-500 bg-gradient-to-b from-emerald-500/10 to-green-500/10 shadow-2xl shadow-emerald-500/20'

                           : 'border-slate-700 bg-slate-800/50 hover:border-slate-500']"

              >

                <!-- Badge "Más popular" para el plan del medio -->

                <div v-if="idx === 1"

                     class="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-emerald-500 to-green-600 text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg whitespace-nowrap">

                  ⭐ Más Popular

                </div>



                <!-- Nombre del plan -->

                <div class="mb-4">

                  <h4 class="text-white font-bold text-lg">{{ plan.nombrePlan }}</h4>

                  <p class="text-slate-400 text-sm mt-1">{{ plan.descripcion }}</p>

                </div>



                <!-- Precio -->

                <div class="mb-6">

                  <!-- Con promoción: precio tachado + precio con descuento -->

                  <template v-if="promoParaPlan(plan)">

                    <div class="flex items-baseline gap-1 mb-0.5">

                      <span class="text-slate-500 text-sm line-through">$</span>

                      <span class="text-xl font-semibold text-slate-500 line-through">{{ formatPrecio(plan.precio) }}</span>

                      <span class="text-slate-500 text-xs line-through">/mes</span>

                    </div>

                    <div class="flex items-baseline gap-1">

                      <span class="text-orange-400 text-sm">$</span>

                      <span class="text-4xl font-black"
                            :class="idx === 1 ? 'text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-pink-400' : 'text-orange-400'">

                        {{ Math.floor(plan.precio * (1 - promoParaPlan(plan).porcentaje / 100)).toLocaleString('es-MX') }}

                      </span>

                      <span class="text-slate-400 text-sm">/mes</span>

                    </div>

                  </template>

                  <!-- Sin promoción: precio normal -->

                  <div v-else class="flex items-baseline gap-1">

                    <span class="text-slate-400 text-sm">$</span>

                    <span class="text-4xl font-black price-tag"
                          :class="idx === 1 ? 'text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-green-400' : 'text-white'">

                      {{ formatPrecio(plan.precio) }}

                    </span>

                    <span class="text-slate-400 text-sm">/mes</span>

                  </div>

                </div>



                <!-- Características -->

                <ul class="space-y-3 flex-1 mb-6">

                  <li

                    v-for="carac in plan.caracteristicas"

                    :key="carac.idCaracteristica"

                    class="flex items-start gap-2.5 text-sm"

                  >

                    <span class="flex-shrink-0 mt-0.5">

                      <i v-if="carac.incluida === 'S'" class="fa-solid fa-circle-check text-emerald-400"></i>

                      <i v-else class="fa-solid fa-circle-xmark text-slate-600"></i>

                    </span>

                    <span :class="carac.incluida === 'S' ? 'text-slate-200' : 'text-slate-500 line-through'">

                      {{ carac.descripcion }}

                    </span>

                  </li>

                </ul>



                <!-- Botón de contratación -->

                <button

                  :class="['w-full py-3 rounded-xl font-bold text-sm transition-all duration-200 hover:scale-105',

                           idx === 1

                             ? 'bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-400 hover:to-green-500 text-white shadow-lg shadow-emerald-500/30'

                             : 'bg-slate-700 hover:bg-slate-600 text-white border border-slate-600']"

                  @click="contactarPlan(plan)"

                >

                  <i class="fa-solid fa-rocket mr-2"></i>

                  Contratar {{ plan.nombrePlan }}

                </button>

              </div>

            </div>



            <!-- Footer del modal -->

            <p class="text-center text-slate-500 text-xs mt-6">

              <i class="fa-solid fa-shield-halved text-slate-600 mr-1"></i>

              Todos los planes incluyen soporte técnico. Precios en MXN sin IVA.

            </p>

          </div>

        </div>

      </div>

    </transition>



  </div>

</template>



<script>

import { mapGetters }  from 'vuex'
import servicioSistema from '@/services/sistemas.service'
import servicioPlan    from '@/services/planes.service'
import servicioPromo   from '@/services/promociones.service'



export default {

  name: 'HomeView',

  computed: {
    ...mapGetters(['estaAutenticado', 'esAdmin', 'usuarioActual']),

    // Solo las promociones vigentes que aplican a al menos un plan visible en el modal
    promocionesAplicables () {
      return this.promocionesVigentes.filter(p =>
        p.todasLosPlanes ||
        (p.idPlanes && this.planes.some(plan => p.idPlanes.includes(plan.idPlan)))
      )
    }
  },

  data () {

    return {

      sistemas:          [],

      planes:            [],

      cargando:          false,

      cargandoPlanes:    false,

      modalPlanes:       false,

      promocionesVigentes: [],

      sistemaSeleccionado: null,

      scrolled:          false,

      mobileMenuOpen:    false,

      aniActual:         new Date().getFullYear(),



      stats: [

        // { valor: '6+',   label: 'Sistemas disponibles'  },

        // { valor: '100+', label: 'Clientes satisfechos'  },

        { valor: '3',    label: 'Planes por sistema'    },

        { valor: '24/7', label: 'Soporte técnico'       }

      ],



      pasos: [

        {

          icono:       '🖥️',

          gradiente:   'linear-gradient(135deg, #6366F1, #8B5CF6)',

          titulo:      'Elige tu sistema',

          descripcion: 'Explora nuestros sistemas y encuentra el que se adapta a tu tipo de negocio.'

        },

        {

          icono:       '📋',

          gradiente:   'linear-gradient(135deg, #EC4899, #7C3AED)',

          titulo:      'Selecciona tu plan',

          descripcion: 'Compara precios y características. Elige el plan que mejor se ajuste a tu presupuesto.'

        },

        {

          icono:       '✅',

          gradiente:   'linear-gradient(135deg, #10B981, #065F46)',

          titulo:      'Comienza a operar',

          descripcion: 'Nuestro equipo te configura el sistema en menos de 24 horas. ¡Listo para operar!'

        }

      ]

    }

  },

  mounted () {

    this.cargarSistemas()

    window.addEventListener('scroll', this.onScroll)

  },

  beforeDestroy () {

    window.removeEventListener('scroll', this.onScroll)

  },

  methods: {

    cerrarSesion () {
      this.$store.dispatch('cerrarSesion')
      this.$router.push({ name: 'Login' })
    },

    onScroll () {

      this.scrolled = window.scrollY > 50

    },



    formatPrecio (valor) {

      return Number(valor).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })

    },

    promoParaPlan (plan) {
      return this.promocionesVigentes.find(p =>
        p.todasLosPlanes || (p.idPlanes && p.idPlanes.includes(plan.idPlan))
      ) || null
    },

    async cargarSistemas () {

      this.cargando = true

      try {

        const res = await servicioSistema.sistemasCon()

        this.sistemas = (res.data.sistemas || []).filter(s => s.estatus === 'A')

      } catch {

        /* Se muestran sistemas desde la BD al estar disponible la API */

      } finally {

        this.cargando = false

      }

    },



    async verPlanes (sistema) {

      this.sistemaSeleccionado = sistema

      this.planes              = []

      this.modalPlanes         = true

      this.cargandoPlanes      = true

      document.body.classList.add('overflow-hidden')



      try {

        const [resPlanes, resPromos] = await Promise.all([

          servicioPlan.planesConCaracteristicasCon(sistema.idSistema),

          servicioPromo.promocionesCon(true)

        ])

        this.planes              = resPlanes.data.planes  || []

        this.promocionesVigentes = resPromos.data.promociones || []

      } catch {

        this.planes              = []

        this.promocionesVigentes = []

      } finally {

        this.cargandoPlanes = false

      }

    },



    cerrarModal () {

      this.modalPlanes         = false

      this.promocionesVigentes = []

      document.body.classList.remove('overflow-hidden')

    },



    contactarPlan (plan) {

      const msg = `Hola, me interesa el plan *${plan.nombrePlan}* del sistema *${this.sistemaSeleccionado.nombre}* ($${this.formatPrecio(plan.precio)}/mes).`

      const url = `https://wa.me/526673041527?text=${encodeURIComponent(msg)}`

      window.open(url, '_blank')

    }

  }

}

</script>



